import React, { useState } from "react";
import "../DashboardStyles.scss";

const SupervisorView = (props) => {
  return <div className="new-dashboard-container"></div>;
};

export default SupervisorView;
